import CourseTypeList from "./components/List"
import CourseTypeForm from "./components/Form"
import CourseTypeView from "./components/View"

let module = "coursetypes"

export default [
  {
    path: "coursetypes",
    component: CourseTypeList,
    meta: { module: module, permissions: ["coursetype-access"] }
  },
  {
    path: "coursetypes/create",
    component: CourseTypeForm,
    props: true,
    meta: { module: module, permissions: ["coursetype-create"] }
  },
  {
    path: "coursetypes/edit/:id",
    component: CourseTypeForm,
    props: true,
    meta: { module: module, permissions: ["coursetype-edit"] }
  },
  {
    path: "coursetypes/view/:id",
    component: CourseTypeView,
    props: true,
    meta: { module: module, permissions: ["coursetype-access"] }
  }
]
